import React from 'react';
import PropTypes from 'prop-types';
import AvtechApplicationCodes from '@avtechsoftware/ra-javascript-utilities/src/types/AvtechApplicationCodes';
import MetricsDetailsPage
  from '@avtechsoftware/react-component-library/src/components/metrics/MetricsDetailsPage/MetricsDetailsPage';
import { masterDeviceListPropType } from '@avtechsoftware/react-component-library/src/types/AvtechPropTypes';
import { withRouter } from 'react-router-dom';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import ConditionalRender
  from '@avtechsoftware/react-component-library/src/components/common/ConditionalRender/ConditionalRender';
import { connect } from 'react-redux';
import envConfig from '../../../envConfig';
import { sessionHash } from '../../../utility/remoteServiceUtil';
import { RaaRoles, sessionUserHasRolePrivileges } from '../../../utility/SecurityRules';
import MaxReportsBanner from '../../layout/MaxReportsBanner/MaxReportsBanner';
import { getAnalogComputedUnit } from '../../../redux/slices/deviceList/deviceListHelperUtils';
import PublicReportModalConnected from '../../public/PublicReportModalConnected/PublicReportModalConnected';
import {
  selectActiveSubscriptionCounts,
  selectSessionHash,
  selectSessionInformation,
  sessionInformationPropType,
} from '../../../redux/slices/sessionSlice';
import {
  selectByUuidOrMacAddress,
  selectRoomAlertDeviceList,
  selectSensorMap,
} from '../../../redux/slices/deviceList/deviceListSlice';
import {
  selectActiveAlertEventList,
  selectActiveAlertEventsForAlertId,
} from '../../../redux/slices/alertEvents/alertEventsSlice';
import {
  dismissAllMessages,
  dismissMessage,
  pushSessionMessage,
  selectAllToastNotifications,
} from '../../../redux/slices/toastNotificationSlice/toastNotificationSlice';
import {
  selectAllThresholdRanges,
  selectThresholdRangeById,
} from '../../../redux/slices/thresholdRangeSlice/thresholdRangeSlice';
import { connectModalContainerContextToComponent } from '../../../contexts/ModalContext/ModalContext';
import {
  getMetricsGroupContextRedux,
  selectAllMetricsGroups,
  selectMetricGroupById,
  selectMetricGroupCrudStatus,
} from '../../../redux/slices/metricsGroupSlice/metricsGroupSlice';
import { store } from '../../../redux/store';
import { CrudStatus } from '../../../utility/types/CrudStatus';
import RaaAuthenticatedRemoteService from '../../../utility/RaaAuthenticatedRemoteService';

class MetricGroupDetailsPageConnected extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alertList: [],
      isAlertListDataLoaded: false,
      showPublicReportModal: false,
      // errorList: [],
    };
    this.getFullAlertList = this.getFullAlertList.bind(this);
    this.getAlertById = this.getAlertById.bind(this);
    this.redirectToMetricGroupPage = this.redirectToMetricGroupPage.bind(this);
    this.redirectToAlertForm = this.redirectToAlertForm.bind(this);
    this.redirectToMetricsGroupList = this.redirectToMetricsGroupList.bind(this);
    this.hidePublicUrlModal = this.hidePublicUrlModal.bind(this);
    this.showPublicUrlModal = this.showPublicUrlModal.bind(this);
  }

  async componentDidMount() {
    await RaaAuthenticatedRemoteService.globalInstance().get(`${envConfig.apiUrl}/api/v1/alerts`)
      .then((response) => {
        this.setState({
          isAlertListDataLoaded: true,
          alertList: [...response.alertList],
        });
      })
      .catch(() => {
        // error handling
      });
  }

  getFullAlertList() {
    const { alertList } = this.state;
    return alertList;
  }

  getAlertById(id) {
    const { alertList } = this.state;
    return alertList.find((alert) => alert.id === id);
  }

  // eslint-disable-next-line class-methods-use-this
  redirectToAlertForm(channelKeyList) {
    window.location.assign(`${envConfig.raaUrl}/alerts/new/${channelKeyList}`);
  }

  redirectToMetricGroupPage(metricGroupId) {
    const { history } = this.props;
    history.push(`/s/sensor-data/groups/${metricGroupId}`);
  }

  // eslint-disable-next-line class-methods-use-this
  redirectToAlertDetails(alertId) {
    window.location.assign(`${envConfig.raaUrl}/s/alerts/${alertId}`);
  }

  // eslint-disable-next-line class-methods-use-this
  redirectToDevicePage(deviceData) {
    let path;
    switch (deviceData.type) {
      case 'CONNECT':
        path = `/links/${deviceData.id}`;
        break;
      default:
        path = `/s/devices/${deviceData.id}`;
    }
    window.location.assign(`${envConfig.raaUrl}${path}`);
  }

  // eslint-disable-next-line class-methods-use-this
  redirectToMetricsGroupList() {
    const { history } = this.props;
    history.push('/s/sensor-data/groups');
  }

  // eslint-disable-next-line class-methods-use-this
  redirectToUpgradeAccount() {
    window.location.assign(`${envConfig.raaUrl}/s/subscription/billing/change-plan`);
  }

  hidePublicUrlModal() {
    this.setState({ showPublicReportModal: false });
  }

  showPublicUrlModal() {
    this.setState({ showPublicReportModal: true });
  }

  // eslint-disable-next-line class-methods-use-this
  renderLoadingSpinner() {
    return (
      <div className="row d-flex justify-content-center mt-5">
        <div>
          <ProgressSpinner progressText="" />
        </div>
      </div>
    );
  }

  render() {
    const {
      id,
      activeSubscriptionCounts,
      sessionInformation,
      metricsGroupContext,
      toastNotificationContext,
      activeAlertEventListForId,
      activeAlertEventList,
      thresholdRangeContext,
      setModalJSX,
      dispatch,
      masterDeviceList,
      metricGroupCrudStatus,
    } = this.props;
    const {
      isAlertListDataLoaded, showPublicReportModal,
    } = this.state;
    const { reportCount, reportLimit } = activeSubscriptionCounts;
    const { activeSubscription, airSpeedScale } = sessionInformation;
    const additionalHeaderContent = (
      <MaxReportsBanner
        reportCount={reportCount}
        reportLimit={reportLimit}
        hasAdminPrivileges={
          sessionUserHasRolePrivileges(activeSubscription, [RaaRoles.ADMIN])
        }
      />
    );

    /* istanbul ignore next */
    const metricsGroupContextRedux = {
      ...metricsGroupContext,
      ...getMetricsGroupContextRedux(dispatch),
      findById: (mId) => selectMetricGroupById(store.getState(), mId),
      findAll: () => selectAllMetricsGroups(store.getState()),
    };
    const metricGroup = metricsGroupContextRedux.findById(id);

    // complexity in mocking above selector
    /* istanbul ignore next */
    if (!metricGroup) {
      if (metricGroupCrudStatus !== CrudStatus.PENDING) {
        this.redirectToMetricsGroupList();
      } else {
        return this.renderLoadingSpinner();
      }
    }

    /* istanbul ignore next */
    if (!isAlertListDataLoaded) {
      return this.renderLoadingSpinner();
    }

    /* istanbul ignore next */
    return (
      <>
        {' '}
        <MetricsDetailsPage
          id={id}
          applicationCode={AvtechApplicationCodes.RAA}
          temperatureScale={sessionInformation.temperatureScale}
          channelsApiUrl={`${envConfig.apiUrl}/api/v1/device-data/channels/fetch-all?auth_token=${sessionHash}`}
          csvReportUrlBase={`${envConfig.apiUrl}/api/v1/device-data/device/samples/csv/find-by-channel-keys`}
          reportDataUrlBase={`${envConfig.apiUrl}/api/v1/device-data/device/samples/find-by-channel-keys`}
          latestSamplesApiUrl={`${envConfig.apiUrl}/api/v1/device-data/latest-samples?auth_token=${sessionHash}`}
          getAnalogComputedUnit={
          (thresholdData) => getAnalogComputedUnit(thresholdData, masterDeviceList.getSensorMap())
}
          remoteService={RaaAuthenticatedRemoteService.globalInstance()}
          metricsGroupContext={metricsGroupContextRedux}
          pushSessionMessage={(level, title, body) => dispatch(
            toastNotificationContext.pushSessionMessage(
              {
                level, title, body,
              },
            ),
          )}
          masterDeviceList={masterDeviceList}
          userHasActionPrivileges={sessionUserHasRolePrivileges(activeSubscription,
            [RaaRoles.ADMIN, RaaRoles.MANAGER])}
          userJwt={`${sessionHash}`}
          getFullAlertList={this.getFullAlertList}
          getActiveAlertEventList={() => activeAlertEventList}
          getAlertById={this.getAlertById}
          getActiveAlertEventsForAlertId={(alertId) => activeAlertEventListForId(alertId)}
          timeZoneName={sessionInformation.timezone}
          redirectToAlertForm={this.redirectToAlertForm}
          redirectToMetricGroupPage={this.redirectToMetricGroupPage}
          redirectToAlertDetails={this.redirectToAlertDetails}
          redirectToDevicePage={this.redirectToDevicePage}
          redirectToMetricsGroupList={this.redirectToMetricsGroupList}
          userHasEditPrivileges={
            sessionUserHasRolePrivileges(activeSubscription,
              [RaaRoles.ADMIN, RaaRoles.MANAGER])
          }
          additionalHeaderContent={additionalHeaderContent}
          thresholdRangeContext={thresholdRangeContext}
          enableThresholdRanges
          enablePublicLink
          createPublicLinkUrl={this.showPublicUrlModal}
          dataLimitUnit={activeSubscriptionCounts.dataAgeLimitUnit}
          dataLimitValue={activeSubscriptionCounts.dataAgeLimitValue}
          onUpgradeClick={this.redirectToUpgradeAccount}
          enableDataLimit
          toggleGroupFavorite={metricsGroupContextRedux.toggleMetricGroupFavorite}
          enablePdfDownload
          pdfDownloadUrlBase="/reports/pdf/"
          userHasAdminPrivileges={
         sessionUserHasRolePrivileges(activeSubscription, [RaaRoles.ADMIN])
       }
          setModalJSX={setModalJSX}
          random={metricsGroupContextRedux.key}
          airSpeedScale={airSpeedScale}
        />
        <ConditionalRender show={showPublicReportModal}>
          <PublicReportModalConnected
            id={id}
            hideModal={this.hidePublicUrlModal}
            metricsGroupContext={metricsGroupContextRedux}
            sessionInformation={sessionInformation}
          />
        </ConditionalRender>
      </>
    );
  }
}

MetricGroupDetailsPageConnected.propTypes = {
  id: PropTypes.number.isRequired,
  sessionInformation: sessionInformationPropType.isRequired,
  activeSubscriptionCounts: PropTypes.objectOf(PropTypes.any).isRequired,
  metricsGroupContext: PropTypes.shape({
    findAll: PropTypes.func.isRequired,
    findById: PropTypes.func.isRequired,
  }).isRequired,
  toastNotificationContext: PropTypes.shape({
    dismissMessage: PropTypes.func.isRequired,
    dismissAllMessages: PropTypes.func.isRequired,
    pushSessionMessage: PropTypes.func.isRequired,
  }).isRequired,
  activeAlertEventList: PropTypes.arrayOf(
    PropTypes.shape({ alertId: PropTypes.string.isRequired }),
  ).isRequired,
  activeAlertEventListForId: PropTypes.func.isRequired,
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
  thresholdRangeContext: PropTypes.shape({
    findAll: PropTypes.func.isRequired,
    findById: PropTypes.func.isRequired,
  }).isRequired,
  setModalJSX: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  masterDeviceList: masterDeviceListPropType.isRequired,
  metricGroupCrudStatus: PropTypes.number.isRequired,
};

/* istanbul ignore next */
const mapStateToProps = (state) => ({
  sessionInformation: selectSessionInformation(state),
  activeSubscriptionCounts: selectActiveSubscriptionCounts(state),
  sessionHash: selectSessionHash(state),
  thresholdRangeContext: {
    findById: (id) => selectThresholdRangeById(state, id),
    findAll: () => selectAllThresholdRanges(state),
  },
  toastNotificationContext: {
    getAllMessages: () => selectAllToastNotifications(state),
    dismissMessage: (id) => dismissMessage(id),
    pushSessionMessage: (message) => pushSessionMessage(message),
    dismissAllMessages: () => dismissAllMessages(),
  },
  activeAlertEventList: selectActiveAlertEventList(state),
  activeAlertEventListForId: (alertId) => selectActiveAlertEventsForAlertId(state, alertId),
  masterDeviceList: {
    findByUUID: (uuid) => selectByUuidOrMacAddress(state, uuid),
    getFullDeviceList: () => selectRoomAlertDeviceList(state),
    getSensorMap: () => selectSensorMap(state),
  },
  metricsGroupContext: {
    findById: () => {},
    findAll: () => {},
  },
  metricGroupCrudStatus: selectMetricGroupCrudStatus(state),
});
export { MetricGroupDetailsPageConnected };

export default withRouter(
  connectModalContainerContextToComponent(
    connect(mapStateToProps)(MetricGroupDetailsPageConnected),
  ),
);
